module.exports = __webpack_public_path__ + "img/404.20f91ede.png";